import { Product } from "./product";
import { ReceiptType } from "./receipt";

export interface Theme {
  contrast: boolean;
  ctaButtonColor: string;
  darkColor: string;
  lightColor: string;
  primaryColor: string;
  searchButtonColor: string;
  startscreenImageCdnUrl: string;
}

export interface Shop {
  id: number;
  type: ReceiptType;
  language: string;
  name: string;
  property: {
    id: number;
    name: string;
    logoCdnUrl: string | null;
    logoUrl: string | null;
    theme: Theme;
    vouchersEnabled: boolean;
    validateLegalAge: boolean | null;
    address: string | null;
    city: string | null;
    postalCode: string | null;
  };
  receiptName: string;
  shortcutProductIds: Product["id"][];
}

export interface CashRegister {
  extTerminalId: string;
  id: number;
  merchant: string;
  model: RegisterModel;
  shop: Shop;
  shopId: number;
}

export enum RegisterModel {
  TABLE = "table",
  FLOOR = "floor",
}
